<template>
  <svg
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="27.5"
      cy="27.5"
      r="27.5"
      fill="url(#paint0_linear_11269_14963)"
    />
    <path
      d="M37.375 23.3125H18.625C18.1277 23.3125 17.6508 23.51 17.2992 23.8617C16.9475 24.2133 16.75 24.6902 16.75 25.1875V36.4375C16.75 36.9348 16.9475 37.4117 17.2992 37.7633C17.6508 38.115 18.1277 38.3125 18.625 38.3125H37.375C37.8723 38.3125 38.3492 38.115 38.7008 37.7633C39.0525 37.4117 39.25 36.9348 39.25 36.4375V25.1875C39.25 24.6902 39.0525 24.2133 38.7008 23.8617C38.3492 23.51 37.8723 23.3125 37.375 23.3125ZM37.375 36.4375H18.625V25.1875H37.375V36.4375ZM18.625 20.5C18.625 20.2514 18.7238 20.0129 18.8996 19.8371C19.0754 19.6613 19.3139 19.5625 19.5625 19.5625H36.4375C36.6861 19.5625 36.9246 19.6613 37.1004 19.8371C37.2762 20.0129 37.375 20.2514 37.375 20.5C37.375 20.7486 37.2762 20.9871 37.1004 21.1629C36.9246 21.3387 36.6861 21.4375 36.4375 21.4375H19.5625C19.3139 21.4375 19.0754 21.3387 18.8996 21.1629C18.7238 20.9871 18.625 20.7486 18.625 20.5ZM20.5 16.75C20.5 16.5014 20.5988 16.2629 20.7746 16.0871C20.9504 15.9113 21.1889 15.8125 21.4375 15.8125H34.5625C34.8111 15.8125 35.0496 15.9113 35.2254 16.0871C35.4012 16.2629 35.5 16.5014 35.5 16.75C35.5 16.9986 35.4012 17.2371 35.2254 17.4129C35.0496 17.5887 34.8111 17.6875 34.5625 17.6875H21.4375C21.1889 17.6875 20.9504 17.5887 20.7746 17.4129C20.5988 17.2371 20.5 16.9986 20.5 16.75Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11269_14963"
        x1="27.5"
        y1="0"
        x2="27.5"
        y2="55"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#357DF9" />
        <stop offset="1" stop-color="#590B73" />
      </linearGradient>
    </defs>
  </svg>
</template>
